import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { IPet } from '../../../interfaces/types.ts'
import { ButtonWrapperSimple } from './ButtonWrapperSimple.tsx'
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons/faClockRotateLeft'
import historyStore from '../../../store/historyStore.ts'
import drawerStore from '../../../store/drawerStore.ts'

interface Props {
    iconOnly?: boolean
    pet: IPet
    textOnly?: boolean
    outline?: boolean
}

export const PetHistoryButton: React.FC<Props> = (props) => {
    const {iconOnly, pet, textOnly, outline} = props
    const navigate = useNavigate()

    const showHistory = () => {
        const path = window.location.pathname
        if ( path === '/history') {
            historyStore.getState().setSelectedPetId(pet._id)
            drawerStore.getState().setDrawerOpen(false)
        } else {
            const state = {pet}
            navigate('/history', {state})
        }
    }

    return !textOnly ? (
        <div className={'cursor-pointer'}>
            <ButtonWrapperSimple outline={outline} icon={faClockRotateLeft as any} iconOnly={iconOnly} label={'History'} pet={pet} onClick={showHistory} full/>
        </div>
    ) : <div className={'font-semibold text-primary'}>History</div>
}
